<script setup lang="ts">
import Card from 'primevue/card'
const { formattedNumber } = useFormattedNumber()
const props = defineProps<{ value?: number | string; label?: string }>()
const formattedValue = computed(() => {
  if (!props.value) return 0
  if (typeof props.value === 'string') return props.value
  return formattedNumber(props.value)
})
</script>
<template>
  <Card>
    <template #title>{{ formattedValue }}</template>
    <template #content>
      <p>
        {{ label }}
      </p>
    </template>
  </Card>
</template>
<style lang="scss" scoped>
@import 'App.scss';

.p-card::v-deep {
  .p-card-body {
    padding: 1rem 1.5rem;
    .p-card-content {
      padding: 0;
      color: $gray;
      font-size: 0.875rem;
      text-transform: capitalize;
    }
  }

  .p-card-title {
    font-size: 1.5rem;
    color: $dark;
  }
}
</style>
